import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { RentalAgreementActivityEventHydration } from './rental-agreement-activity-event-hydration.dto';

/**
 * A rental agreement activity event with hydrated related records.
 */
export class RentalAgreementActivityEventDto extends ActivityEventDto {
  hydrated?: RentalAgreementActivityEventHydration;
}
